module.exports = __webpack_public_path__ + "files/a72b17a8c413f7b942936bbbb8081b5b.svg";